import React from 'react';
import { observer } from 'mobx-react-lite';
import { useAddQuotePageStore } from 'store/pages/quote/add-quote/pageStore';
import { getProductLinesFromArray } from '@insurancemenu/imenu-components-lib/dist/utils/ProductLinesHelper';
import { AddQuoteValidationError } from 'store/pages/quote/add-quote/types';
import { ADD_QUOTE_TEST_IDS } from '../constants';
import { AlertStyled } from './styles';

const ValidationError: React.FC<AddQuoteValidationError> = (error) => {
  switch (error.type) {
    case 'NO_PLANS':
      return <>Add at least one plan to continue</>;
    case 'DEPENDENT_PRODUCT_LINES':
      return (
        <>
          Elect <b>{getProductLinesFromArray(error.productLineIds)}</b> to proceed
        </>
      );
    default:
      return null;
  }
};

const AddQuoteValidationAlert: React.FC = observer(() => {
  const { isActionLoading, validationErrors } = useAddQuotePageStore();

  if (isActionLoading || validationErrors.length === 0) {
    return null;
  }

  return (
    <AlertStyled
      data-testid={ADD_QUOTE_TEST_IDS.VALIDATION_ALERT}
      title="Please review the following issues"
      type="error"
      content={validationErrors.map((error) => (
        <ValidationError key={error.type} {...error} />
      ))}
    />
  );
});

export default AddQuoteValidationAlert;
